import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, Form, Row, Select, Typography } from "antd";
import { viLocale as locale } from "../../../../../utils/pickerType";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FormInput from "../../../../../components/form-input/FormInput";
import { countRatingByCourse } from "../../../../../service/course-management";
import { objectToQueryString } from "../../../../../utils/getPageFromLink";
import "./filter-table.scss";

interface FormFilterProps {
  handleCloseFilter: () => void
  showFilter: boolean;
  setFilterData: (values: any) => void;
  dataOptions?: any;
}


const FormFilter = (props: FormFilterProps) => {
  const { t } = useTranslation();
  const { showFilter, setFilterData } = props
  const [form] = Form.useForm();
  const { Title } = Typography;
  const { RangePicker } = DatePicker;
  const [starRating, setStarRating] = useState<any>([])
  const { courseId } = useParams()

  const handleFinish = (values: any) => {
    setFilterData(values)
  };

  const starOptions = [
    { label: `1 ${t("sao", "sao")} (${starRating?.[0]?.total ?? 0})`, value: 1 },
    { label: `2 ${t("sao", "sao")} (${starRating?.[1]?.total ?? 0})`, value: 2 },
    { label: `3 ${t("sao", "sao")} (${starRating?.[2]?.total ?? 0})`, value: 3 },
    { label: `4 ${t("sao", "sao")} (${starRating?.[3]?.total ?? 0})`, value: 4 },
    { label: `5 ${t("sao", "sao")} (${starRating?.[4]?.total ?? 0})`, value: 5 },
  ];

  useEffect(() => {
    const payload = {
      courseId: courseId,
      status: "1"
    }
    const fetchData = async () => {
      try {
        const res = await countRatingByCourse(objectToQueryString(payload))
        setStarRating(res?.data)
      } catch (error) {

      }
    }
    fetchData()
  }, [])

  return (
    <div className={`wrapper-filter p-6  ${showFilter ? "open" : ""}`}>
      <Form form={form} onFinish={handleFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={5}>{t("Sao đánh giá", "Sao đánh giá")}</Title>
            <Form.Item name="stars" className="mb-0">
              <Checkbox.Group options={starOptions} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5}>{t("Học viên", "Học viên")}</Title>
            <Form.Item name="student" className="mb-0">
              <FormInput
                placeholder={t("Nhập tên học viên", "Nhập tên học viên")}
              //  onChange={handleChangeInput}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5}>{t("Trạng thái", "Trạng thái")}</Title>
            <Form.Item name="status" className="mb-0">
              <Select placeholder={t("Trạng thái", "Trạng thái")}>
                <Select.Option value={0}>{t("Đã phản hồi", "Đã phản hồi")}</Select.Option>
                <Select.Option value={1}>{t("Chưa phản hồi", "Chưa phản hồi")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5}>{t("Thời gian tạo", "Thời gian tạo")}</Title>
            <Form.Item name="timeCreated" className="mb-0"
            >
              <RangePicker
                format={"YYYY-MM-DD HH:mm"}
                locale={locale}
                showTime
                placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}

              />
            </Form.Item>
          </Col>
          <Col
            xs={24} sm={12} md={6}
            className="flex align-end"
          >
            <div className="group-btn--filter">
              <Button
                className="btn btn-primary search-btn"
                onClick={() => form.submit()}
              >
                <FilterOutlined />
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={() => {
                  form.resetFields();
                  setFilterData({});
                }}
              >
                <DeleteOutlined />
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>

      </Form>
    </div>
  );
};

export default FormFilter;
